
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iframe",
      function () {
        return require("private-next-pages/iframe/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iframe"])
      });
    }
  